import { useIntl } from 'react-intl'
import cruiseGlossaryMessages from 'hooks/Cruise/cruiseGlossaryMessages'

function useCruiseCabinTypeLabels(): Record<string, string> {
  const intl = useIntl()

  return {
    Inside: intl.formatMessage(cruiseGlossaryMessages.cabinInside),
    Oceanview: intl.formatMessage(cruiseGlossaryMessages.cabinOceanview),
    Window: intl.formatMessage(cruiseGlossaryMessages.cabinWindow),
    'Oceanview / Window': intl.formatMessage(cruiseGlossaryMessages.oceanviewOrWindow),
    Balcony: intl.formatMessage(cruiseGlossaryMessages.cabinBalcony),
    Suite: intl.formatMessage(cruiseGlossaryMessages.cabinSuite),
  }
}

export default useCruiseCabinTypeLabels
